export default __webpack_public_path__ + "static/media/unlock.97277a91.svg";